import { render, staticRenderFns } from "./HomeTC.vue?vue&type=template&id=12fea0a5"
import script from "./HomeTC.vue?vue&type=script&lang=js"
export * from "./HomeTC.vue?vue&type=script&lang=js"
import style0 from "./HomeTC.vue?vue&type=style&index=0&id=12fea0a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports